@if (facilityId$ | async; as facilityId) {
  <div class="layout-col full p-md">
    @if (schedule$ | async; as schedule) {
      <div class="flex">
        <app-weekly-schedule-edit class="flex" [weekSchedule]="schedule.weekSchedule">
        </app-weekly-schedule-edit>
      </div>
    } @else {
      <div>
        <button mat-button (click)="onNewSchedule()">
          <mat-icon>add</mat-icon>
          {{ 'optimization.schedule.title' | translate }}
        </button>
      </div>
    }
  </div>
}
